// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Facebook: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
            <g fill="none" fillRule="evenodd">
                <rect width="31" height="31" x=".5" y=".5" stroke="#FFF" opacity=".33" />
                <path
                    fill="#FFF"
                    d="M17.1160624,13.3570259 L17.1160624,11.8000567 C17.1160624,11.2157209 17.505083,11.0792026 17.7788207,11.0792026 L19.4610979,11.0792026 L19.4610979,8.50897525 L17.1445273,8.5 C14.5722467,8.5 13.9872924,10.4169239 13.9872924,11.6436984 L13.9872924,13.3570259 L12.5,13.3570259 L12.5,16.0051962 L13.9872924,16.0051962 L13.9872924,23.5 L17.1160624,23.5 L17.1160624,16.0051962 L19.2267367,16.0051962 L19.5,13.3570259 L17.1160624,13.3570259 Z"
                />
            </g>
        </svg>
    );
};

export default React.memo(Facebook);
